import { useState, useCallback } from 'react'
import {
  togglePostModalEventDispatch,
  togglePostSidebarFullScreenEventListener,
  ToggleRichTextFullScreenSidebarEvent
} from 'src/utils/customEvents'
import { MODAL_ACTIONS } from 'src/utils/customEvents/types'

const usePostModalFullScreen = () => {
  const [isOpenPostFullScreenSidebar, setIsOpenPostFullScreenSidebar] = useState<boolean>(false)

  const handleClosePostSidebarFullScreen = useCallback(() => {
    setIsOpenPostFullScreenSidebar(false)
  }, [setIsOpenPostFullScreenSidebar])

  const listenerPostSidebarFull = useCallback(() => {
    /* istanbul ignore next */
    togglePostSidebarFullScreenEventListener((event) => {
      const payload = (event as CustomEvent<ToggleRichTextFullScreenSidebarEvent>).detail

      switch (payload.action) {
        case MODAL_ACTIONS.CLOSE:
          window.document.body.classList.remove('_overflow-hidden')
          setIsOpenPostFullScreenSidebar(false)

          break
        case MODAL_ACTIONS.OPEN:
          window.document.body.classList.add('_overflow-hidden')

          setIsOpenPostFullScreenSidebar(true)
          togglePostModalEventDispatch({ action: MODAL_ACTIONS.CLOSE })
          break
      }
    })
  }, [togglePostSidebarFullScreenEventListener, togglePostModalEventDispatch])

  return {
    isOpenPostFullScreenSidebar,
    setIsOpenPostFullScreenSidebar,
    listenerPostSidebarFull,
    handleClosePostSidebarFullScreen
  }
}

export default usePostModalFullScreen
